import sprintf from 'sprintf';

class SMMessageConnector {
  
  constructor() {
    this.socket = new Pusher(SpaceMarket.Config.PusherKey);
    if (SpaceMarket.Config.Env == "development") {
      Pusher.log = function(log) {
        // console.log(log);
      };
    }
  }
  
  subscribe(reservation, event, callback) {
    if (this.channel) this.unsubscribe();
    this.channel = this.socket.subscribe(sprintf("reservation-%s", reservation.id));
    this.channel.bind(event, callback);
  }
  
  unsubscribe() {
    this.channel.unbind();
    this.channel = null;
  }
}
export default SMMessageConnector;


// WEBPACK FOOTER //
// ./app/javascript/connectors/SMMessageConnector.js